import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { VoucherCodeLightBoxActions } from '../constants/voucher_code_light_box/voucher_code_light_box_actions';

class VoucherCodeLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            loading: false,
            expanded: false,
            invalid: false,
            valid: false,
            obj: null,
            invalidMessage: '',
            validMessage: '',
            code: '',
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.VOUCHER_CODE_LIGHTBOX_ACTION) {
            switch (action.type) {
                case VoucherCodeLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.code = '';
                        state.visible = true;
                        state.loading = false;
                        state.invalid = false;
                        state.invalidMessage = '';
                        state.valid = false;
                        state.validMessage = '';
                        state.obj = action.payload;
                        this.__emitChange();
                    }

                    break;

                case VoucherCodeLightBoxActions.HIDE:
                    if (state.visible) {
                        state.code = '';
                        state.visible = false;
                        state.loading = false;
                        state.invalid = false;
                        state.invalidMessage = '';
                        state.valid = false;
                        state.validMessage = '';
                        state.obj = null;
                        this.__emitChange();
                    }

                    break;
                
                case VoucherCodeLightBoxActions.UPDATE:
                    state.obj = action.payload;
                    this.__emitChange();
                    
                    break;

                case VoucherCodeLightBoxActions.INVALID_ACTION:
                    if (!state.invalid) {
                        state.code = '';
                        state.invalid = true;
                        state.loading = false;
                        state.invalidMessage = action.payload;
                        state.valid = false;
                        state.validMessage = '';
                        this.__emitChange();
                    }
                    break;
                
                case VoucherCodeLightBoxActions.VALID_ACTION:
                    if (!state.valid) {
                        state.code = '';
                        state.valid = true;
                        state.loading = false;
                        state.validMessage = action.payload;

                        state.invalid = false;
                        state.invalidMessage = '';
                        this.__emitChange();
                    }
                    break;
                
                case VoucherCodeLightBoxActions.ADD_LOADING:
                    if (!state.loading) {
                        state.loading = true;
                        state.invalid = false;
                        state.invalidMessage = '';
                        state.valid = false;
                        state.validMessage = '';
                        this.__emitChange();
                    }
                    break;
                
                case VoucherCodeLightBoxActions.REMOVE_LOADING:
                    if (state.loading) {
                        state.loading = false;
                        this.__emitChange();
                    }
                    break;
                
                case VoucherCodeLightBoxActions.UPDATE_CODE:
                    state.code = action.payload;
                    this.__emitChange();
                    break;
            }
        }

        return state;
    }
}

const VoucherCodeLightBoxStore = new VoucherCodeLightBoxStoreClass(Dispatcher);
export { VoucherCodeLightBoxStore };
